/** Stale-build recovery (06 §1.8): a missing chunk after a deploy triggers one SW update and reload. */
import { applyUpdate } from '../pwa/register';

const KEY = 'tarock.protoReloadAt';
const GUARD_MS = 60_000;

/** True for the errors a failed dynamic `import()` produces in Chromium, WebKit and Firefox. */
export function isChunkLoadError(e: unknown): boolean {
  const m = e instanceof Error ? e.message : String(e);
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported|Unable to preload/i.test(
    m,
  );
}

/** Reloads once per minute at most; returns false when the loop guard blocks it (show a manual Reload instead). */
export function reloadForStaleBuild(): boolean {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < GUARD_MS) {
      return false;
    }
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // no sessionStorage: reload anyway
  }
  void applyUpdate().finally(() => location.reload());
  return true;
}
